import { motion } from "framer-motion";

import PropTypes from "prop-types";
import Card from "react-bootstrap/Card";

const Banner = ({ image }) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: ".2" }}
      >
        <Card className="border-0 mx-2">
          <img src={image} className="border-radius-10" alt="banner-slide" />
        </Card>
      </motion.div>
    </>
  );
};

Banner.propTypes = {
  image: PropTypes.string.isRequired,
};

export default Banner;
